// Lightweight IP-based geolocation. Cached per session.
// Uses ipapi.co (free 30k/month). Fails silently.

export type GeoInfo = {
  country?: string;
  country_code?: string;
  region?: string;
  city?: string;
  postal?: string;
  lat?: number;
  lng?: number;
  org?: string;
};

const KEY = "vs_geo_info";

export const getCachedGeo = (): GeoInfo | null => {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

let inflight: Promise<GeoInfo | null> | null = null;

export const fetchGeo = async (): Promise<GeoInfo | null> => {
  const cached = getCachedGeo();
  if (cached) return cached;
  if (inflight) return inflight;

  inflight = (async () => {
    try {
      const res = await fetch("https://ipapi.co/json/", { cache: "force-cache" });
      if (!res.ok) return null;
      const data = await res.json();
      const geo: GeoInfo = {
        country: data.country_name,
        country_code: data.country_code,
        region: data.region,
        city: data.city,
        postal: data.postal,
        lat: typeof data.latitude === "number" ? data.latitude : undefined,
        lng: typeof data.longitude === "number" ? data.longitude : undefined,
        org: data.org,
      };
      sessionStorage.setItem(KEY, JSON.stringify(geo));
      return geo;
    } catch {
      return null;
    } finally {
      inflight = null;
    }
  })();

  return inflight;
};
